import { Button, Card, Tag, Typography } from "antd";
import dayjs from "dayjs";
import React from "react";
import type { Carpool, CarpoolRole } from "../types";

interface Props {
  carpool: Carpool;
  isFull: boolean;
  onJoin: () => void;
  onEdit: () => void;
}

const JOIN_BUTTON_LABEL: Record<CarpoolRole, string> = {
  driver: "Mitfahren",
  rider: "Fahrt anbieten",
  train: "Kontakt aufnehmen",
};

const CONTACT_LABEL: Record<CarpoolRole, string> = {
  driver: "Fahrer",
  rider: "Sucht Mitfahrgelegenheit",
  train: "Zugreisende:r",
};

export const CarpoolCard = ({ carpool, isFull, onJoin, onEdit }: Props) => {
  const isDriver = carpool.role === "driver";
  const showExactTime = carpool.role !== "rider";
  const seatsUsed = carpool.joinRequests.length;
  const seatsTotal = carpool.seats ?? 0;

  return (
    <Card
      size="small"
      style={{ marginBottom: 8 }}
      actions={[
        <Button
          key="join"
          type="primary"
          size="small"
          disabled={isFull}
          onClick={onJoin}
        >
          {JOIN_BUTTON_LABEL[carpool.role]}
        </Button>,
        <Button key="edit" size="small" onClick={onEdit}>
          Bearbeiten
        </Button>,
      ]}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div>
          <Typography.Text strong>
            {carpool.origin} → {carpool.destination}
          </Typography.Text>
          <br />
          <Typography.Text type="secondary">
            {showExactTime
              ? `${dayjs(carpool.departureTime).format("DD.MM.YYYY HH:mm")} Uhr`
              : dayjs(carpool.departureTime).format("DD.MM.YYYY")}
          </Typography.Text>
          {carpool.carType && (
            <>
              <br />
              <Typography.Text type="secondary">{carpool.carType}</Typography.Text>
            </>
          )}
          <br />
          <Typography.Text type="secondary">
            {CONTACT_LABEL[carpool.role]}: {carpool.driverName}
          </Typography.Text>
        </div>
        <div style={{ textAlign: "right" }}>
          {isDriver &&
            (isFull ? (
              <Tag color="red">Voll</Tag>
            ) : (
              <Tag color="green">
                {seatsTotal - seatsUsed} / {seatsTotal} frei
              </Tag>
            ))}
        </div>
      </div>
    </Card>
  );
};
